import React from "react";
import { CHART_COLORS } from "../../constants/chartColors";
import { CampaignTypeFilter } from "../../pages/DashboardTabs/Statistics";
import DetailsBox from "./DetailsBox";

interface DataSummaryProps {
  campaignTypeFilter: CampaignTypeFilter;
  googleValue: string;
  hasMetaCampaignsEnabled: boolean;
  metaValue: string;
  metaWizardFinished: boolean;
  metric: string;
  metricLabel: string;
}

export const DataSummary: React.FC<DataSummaryProps> = ({
  campaignTypeFilter,
  googleValue,
  hasMetaCampaignsEnabled,
  metaValue,
  metaWizardFinished,
  metric,
  metricLabel,
}) => {
  const showGoogle = campaignTypeFilter === CampaignTypeFilter.ALL || campaignTypeFilter === CampaignTypeFilter.GOOGLE;
  const showMeta =
    (campaignTypeFilter === CampaignTypeFilter.ALL || campaignTypeFilter === CampaignTypeFilter.META) &&
    hasMetaCampaignsEnabled &&
    metaWizardFinished;

  // Show metric label only for first 3 metrics: impressions, clicks, conversions
  const showMetricLabel = ["impressions", "clicks", "conversions"].includes(metric);
  const labelToPass = showMetricLabel ? metricLabel : undefined;

  // Only show the summary when both campaigns are visible
  if (!(showGoogle && showMeta)) {
    return null;
  }

  return (
    <div className="typography-mb-4" style={{ margin: "32px 0 28px" }}>
      <div style={{ display: "flex", gap: "14px" }}>
        <DetailsBox campaignType="google" color={CHART_COLORS.google} metricLabel={labelToPass} value={googleValue} />
        <DetailsBox campaignType="meta" color={CHART_COLORS.meta} metricLabel={labelToPass} value={metaValue} />
      </div>
    </div>
  );
};
